export const isLocalHost = (locationString: string) => {
    return locationString.match(/localhost/);
};

export const isTestHost = (locationString: string) => {
    return locationString.match(/test/);
};

export const isLocalOrTestHost = (locationString: string) => {
    return locationString.match(/localhost|test/);
};

export const isDevMode = (url: string) => {
    return url.match(/staging|playground|test|portal-ux/);
};
